import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AlertService } from './services';

@NgModule({
  imports: [CommonModule],
})
export class SharedAlertModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedAlertModule,
      providers: [AlertService],
    };
  }
}
